import type { RootState } from "../types/store.types";

export const selectReports = (state: RootState) => state.reports.reports;
